import React from 'react';
import {HelpAnywhereCaretLeftSmallIcon} from '@apothecary/community-icons';
import PropTypes from 'prop-types';
import {Trans} from '@lingui/macro';
import {connect} from 'react-redux';
import './_Header.scss';

const FullPageHeader = ({
  onBack,
  showReloadAndBack,
  componentShowingInUH,
  renderBreadCrumbs,
  contactModalityShowing
}) => {

  return (
    <div
      data-testid="header"
      className={'header' + (showReloadAndBack ? ' header--with-back' : '')}
    >
      {renderBreadCrumbs()}
      {(showReloadAndBack || contactModalityShowing !== '') && <div className="sub-header__hrule breadcrumb" />}
      {showReloadAndBack ? (
        <div className="sub-header sub-header--full-page">
          <span
            className="header__back-action header__back--full-page"
            data-testid="header-back"
            data-wat-val="back"
            onClick={onBack}
          >
            <HelpAnywhereCaretLeftSmallIcon
              color="#666"
              className="header__back-icon"
            />
            {'  '}
            <Trans>Back</Trans>
          </span>
        </div>
      ) : null}
    </div>
  );
};

const noop = () => {};

// Set default props
FullPageHeader.defaultProps = {
  showReloadAndBack: false,
  onBack: noop,
  renderBreadCrumbs: noop,
};

// Set proptype rules
FullPageHeader.propTypes = {
  showReloadAndBack: PropTypes.bool,
  showAvaModal: PropTypes.bool,
  onBack: PropTypes.func,
  renderBreadCrumbs: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    contactModalityShowing: state.uiOptions.contactModalityShowing,
  };
};

export default connect(mapStateToProps)(FullPageHeader);
